module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "finalizaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "finalizaModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal",
      "dismiss": "modal"
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde",
      "rotulo": "Não",
      "icone": "fa-times fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.discorda()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Sim",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.concorda()
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
  }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliado.pessoa.nome))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliado.registroFormatado))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("Cargo:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliado.cargoPrincipal))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
  }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.avaliacao.avaliador && _vm.avaliacao.avaliador.pessoa && _vm.avaliacao.avaliador.pessoa.nome ? _vm.avaliacao.avaliador.pessoa.nome : 'Nome não disponível') + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.avaliacao.avaliador ? _vm.avaliacao.avaliador.registroFormatado : 'Sem registro') + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Número de Faltas:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeFaltas))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesFaltas))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Número de Atrasos:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeAtrasos))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesAtrasos))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Repreensões:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeRepreensoes))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesRepreensoes))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("NOTA FINAL (A):")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.notaFichaFuncional))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Avaliação de Desempenho")]), _vm._v(" "), (_vm.ehRecemEstavel) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                      O estatutário que\n                      "), _c('strong', [_vm._v("se tornou estável no segundo semestre de\n                        " + _vm._s(_vm.avaliacao.competencia.ano))]), _vm._v("\n                      terá sua nota de desempenho atribuída automaticamente no\n                      sistema, considerando a 5º avaliação do estágio\n                      probatório. "), _c('strong', [_vm._v("Não será necessário")]), _vm._v(" incluir\n                      notas de "), _c('strong', [_vm._v("autoavaliação")]), _vm._v(",\n                      "), _c('strong', [_vm._v("nem ser avaliado")]), _vm._v(" pelo chefe imediato. A\n                      ficha de avaliação de\n                      " + _vm._s(_vm.avaliacao.competencia.ano) + " estará disponível\n                      "), _c('strong', [_vm._v("somente para visualização")]), _vm._v(".\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', [_vm._v("AVALIAÇÃO FICHA FUNCIONAL:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.notaFichaFuncional))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', [_vm._v("AVALIAÇÃO ESTÁGIO PROBATÓRIO:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.mediaEstagioProbatorio))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', [_vm._v("PONTUAÇÃO FINAL:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pontuacaoFinalProbatorio))])])])])])]) : _c('div', [_c('b', [_vm._v("Parâmetros ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-condensed hidden-xs"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.notasOrdenadas), function(nota, index) {
    return _c('tr', {
      key: nota.id,
      class: {
        'has-error': _vm.errors.has('name' + index)
      }
    }, [_c('td', {
      attrs: {
        "data-title": "",
        "align": "left"
      }
    }, [_vm._v("\n                          " + _vm._s(nota.item.codigo) + "\n                        ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Indicadores de Desempenho",
        "align": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(nota.item.titulo) + " ")]), _vm._v(" "), _c('esconde-div', [_vm._v(_vm._s(nota.item.descricao))])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Autoavaliação (B)",
        "align": "left"
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:8'
        ),
        expression: "\n                              'required|numeric|min_value:1|max_value:8'\n                            "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAutoAvaliacao),
        expression: "nota.notaAutoAvaliacao"
      }],
      attrs: {
        "type": "text",
        "size": "3",
        "name": 'notaB' + index,
        "id": 'notaB' + index,
        "data-vv-as": "Nota",
        "disabled": _vm.habilitaCampoAvaliado
      },
      domProps: {
        "value": (nota.notaAutoAvaliacao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAutoAvaliacao", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaB' + index)),
        expression: "errors.has('notaB' + index)"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors.first('notaB' + index)))])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Avaliador (C)",
        "align": "left"
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:8'
        ),
        expression: "\n                              'required|numeric|min_value:1|max_value:8'\n                            "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAvaliador),
        expression: "nota.notaAvaliador"
      }],
      attrs: {
        "type": "text",
        "size": "3",
        "name": 'notaC' + index,
        "id": 'notaC' + index,
        "data-vv-as": "Nota",
        "disabled": _vm.habilitaNotasAvaliador
      },
      domProps: {
        "value": (nota.notaAvaliador)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAvaliador", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaC' + index)),
        expression: "errors.has('notaC' + index)"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors.first('notaC' + index)))])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.somaAutoavaliacao) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.somaAvaliador) + "\n                        ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed visible-xs"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.notasOrdenadas), function(nota, index) {
    return _c('tr', {
      key: nota.id,
      class: {
        'has-error': _vm.errors.has('name' + index)
      }
    }, [_c('td', {
      attrs: {
        "data-title": "",
        "align": "left"
      }
    }, [_vm._v("\n                          " + _vm._s(nota.item.codigo) + "\n                        ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Indicadores de Desempenho",
        "align": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(nota.item.titulo) + " ")]), _vm._v(" "), _c('esconde-div', [_vm._v(_vm._s(nota.item.descricao))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('p', [_vm._v("Autoaval. (B)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:8'
        ),
        expression: "\n                                  'required|numeric|min_value:1|max_value:8'\n                                "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAutoAvaliacao),
        expression: "nota.notaAutoAvaliacao"
      }],
      attrs: {
        "type": "number",
        "name": 'notaB' + index,
        "id": "notaB",
        "data-vv-as": "Nota",
        "disabled": _vm.habilitaCampoAvaliado
      },
      domProps: {
        "value": (nota.notaAutoAvaliacao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAutoAvaliacao", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaB' + index)),
        expression: "errors.has('notaB' + index)"
      }],
      staticClass: "error"
    }, [_vm._v("\n                                " + _vm._s(_vm.errors.first('notaB' + index)))])]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_c('p', [_vm._v("Avaliador (C)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:8'
        ),
        expression: "\n                                  'required|numeric|min_value:1|max_value:8'\n                                "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAvaliador),
        expression: "nota.notaAvaliador"
      }],
      attrs: {
        "type": "number",
        "name": 'notaC' + index,
        "id": "notaC",
        "data-vv-as": "Nota",
        "disabled": _vm.habilitaNotasAvaliador
      },
      domProps: {
        "value": (nota.notaAvaliador)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAvaliador", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaC' + index)),
        expression: "errors.has('notaC' + index)"
      }],
      staticClass: "error"
    }, [_vm._v("\n                                " + _vm._s(_vm.errors.first('notaC' + index)))])])])], 1)])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('b', [_vm._v("TOTAL DE PONTOS: ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', [_vm._v("Autoaval. (B)")]), _vm._v("\n                              " + _vm._s(_vm.somaAutoavaliacao) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', [_vm._v("Avaliador (C)")]), _vm._v("\n                              " + _vm._s(_vm.somaAvaliador) + "\n                            ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("MÉDIA (M) = (B + C) / 2:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mediaAvaliacoes))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("PONTUAÇÃO FINAL (A + M):")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pontuacaoFinal))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("Data da Avaliação")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dataAvaliacao))])])])])])]), _vm._v(" "), (!_vm.ehRecemEstavel) ? _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Anuência")]), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.avaliacao.aceita == true || _vm.avaliacao.aceita == false) ? _c('div', {
    staticClass: "col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8"
  }, [_c('div', {
    staticClass: "card sub-card sub-card-content"
  }, [_c('div', {
    staticClass: "anuencia"
  }, [_vm._v("\n                    Servidor avaliado\n                    "), _c('span', {
    staticClass: "anuencia-resultado"
  }, [_vm._v(_vm._s(_vm.avaliacao.aceita ? 'CONCORDA' : 'NÃO CONCORDA'))]), _vm._v("\n                    com a pontuação final.\n                  ")])])]) : _c('p')])]) : _vm._e()])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.voltar()
      }
    }
  }), _vm._v(" "), (_vm.mostraFinalizar) ? _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Entregar",
      "icone": "fa-check fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.valida('finalizar')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mostraSalvar) ? _c('botao', {
    attrs: {
      "estilo": _vm.mostraFinalizar ? 'vazado-verde-dir' : 'cheio-verde-dir',
      "rotulo": "Salvar",
      "icone": "fa-floppy-o fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.valida('salvar')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: (
        'Visual. impres. finalizadas com Concordo ou Discordo'
      ),
      expression: "\n              'Visual. impres. finalizadas com Concordo ou Discordo'\n            ",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "disabled-tooltip"
  }, [(_vm.mostraImprimir) ? _c('botao', {
    attrs: {
      "estilo": _vm.ehAvaliador ? 'vazado-verde-dir' : 'cheio-verde-dir',
      "rotulo": "Imprimir",
      "icone": "imprimir-tabela",
      "disabled": (_vm.avaliacaoFinalizada || _vm.ehAvaliador || _vm.naoFinalizadoComPeriodoEncerrado) ? false : true
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime(_vm.avaliacao.id)
      }
    }
  }) : _vm._e()], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "finalizaModalLabel"
    }
  }, [_vm._v("\n              Finalizar Avaliação\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Você concorda com o resultado da sua avaliação?\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Funcionário "), _c('small', [_vm._v("(Avaliado)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Chefe Imediato "), _c('small', [_vm._v("(Avaliador)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("\n                Avaliação de Ficha Funcional "), _c('small', [_vm._v("(Preenchido pelo DEGEPAT)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped table-condensed hidden-xs"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Acima do esperado")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Dentro do esperado")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Parcialmente esperado")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Abaixo do esperado")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "data-title": "Acima do esperado",
      "align": "left"
    }
  }, [_vm._v("\n                          (7-8 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Dentro do esperado",
      "align": "left"
    }
  }, [_vm._v("\n                          (5-6 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Parcialmente esperado",
      "align": "left"
    }
  }, [_vm._v("\n                          (3-4 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Abaixo do esperado",
      "align": "left"
    }
  }, [_vm._v("\n                          (1-2 pontos)\n                        ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed visible-xs"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Acima do esperado")]), _vm._v(" "), _c('td', [_vm._v("(7-8 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Dentro do esperado")]), _vm._v(" "), _c('td', [_vm._v("(5-6 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Parcialmente esperado")]), _vm._v(" "), _c('td', [_vm._v("(3-4 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Abaixo do esperado")]), _vm._v(" "), _c('td', [_vm._v("(1-2 pontos)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Indicadores de Desempenho")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "135px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', [_vm._v("Autoavaliação (B)")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "104px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', [_vm._v("Avaliador (C)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("TOTAL DE PONTOS DA AUTOAVALIAÇÃO (B) E DO\n                            AVALIADOR (C):\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Indicadores de Desempenho")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                    Na hipótese de o servidor não concordar com a pontuação\n                    final, poderá negociar com o Avaliador. Essa negociação\n                    das notas deverá ocorrer até o prazo final. Quando as\n                    notas forem definidas, o Avaliado deverá clicar no botão\n                    \"Entregar\" e selecionar dentre as opções “Concordo” ou\n                    “Discordo” e salvar para encerrar a Avaliação. A partir\n                    deste momento as notas não poderão ser alteradas.\n                  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                    Em caso de discordância, o servidor avaliado deverá abrir \n                    processo digital de Recurso de Notas de Avaliação, em até 10 (dez) \n                    dias úteis contados a partir da data do prazo final da avaliação.\n                  ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f0f6c3f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/avaliacao/detalha-avaliacao.vue
// module id = /aLi
// module chunks = 5